// 安全获取 localStorage，兼容预渲染环境
function getLanguage() {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('language') || 'zh'
    }
  } catch (e) {
    // 预渲染环境可能无法访问 localStorage
  }
  return 'zh'
}

export default {
  state: {
    language: getLanguage(),
    metaInfo: {
      title: '',
      keywords: '',
      description: ''
    }
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          localStorage.setItem('language', language)
        }
      } catch (e) {
        // 预渲染环境可能无法访问 localStorage
      }
    },
    CHANGE_META_INFO(state, metaInfo) {
      state.metaInfo = { ...state.metaInfo, ...(metaInfo || {}) }
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setMetaInfo({ commit }, metaInfo) {
      commit('CHANGE_META_INFO', metaInfo)

      if (typeof document !== 'undefined') {
        if (metaInfo && metaInfo.title !== undefined) {
          document.title = metaInfo.title || ''
        }
        const ensureMeta = (name) => {
          let el = document.querySelector(`meta[name="${name}"]`)
          if (!el) {
            el = document.createElement('meta')
            el.setAttribute('name', name)
            document.head.appendChild(el)
          }
          return el
        }
        if (metaInfo && metaInfo.keywords !== undefined) {
          ensureMeta('keywords').setAttribute('content', metaInfo.keywords || '')
        }
        if (metaInfo && metaInfo.description !== undefined) {
          ensureMeta('description').setAttribute('content', metaInfo.description || '')
        }
        // 在预渲染环境中，通知页面已经准备好
        if (typeof window !== 'undefined') {
          window.__PRERENDER_READY__ = true
        }
      }
    }
  }
}